<template>
  <div class="contact-wrapper">
    <div class="contact-content">
      <div class="contact-left">
        <img src="~@/assets/images/contact-map.png" class="map" />
        <div class="desc-box">
          <div class="word">
            <div class="map-tit">天津海河教育园区</div>
            <div class="map-desc">
              位于天津市中心城区和滨海新区之间的海河中游南岸，北至天津大道，南至津港公路、津晋高速，西至蓟汕高速联络线，东至咸水沽西外环，规划总占地37平方公里。
            </div>
          </div>
          <img src="~@/assets/images/hjy.png" />
          <div class="map-desc2">
            园区定位为我国职业教育改革创新示范园区、天津市高端科技研发创新示范区、海河南岸生态宜居示范社区。
          </div>
        </div>
        <p class="location">天津</p>
      </div>
      <div class="contact-right">
        <p class="tit">联系我们</p>
        <p class="time">工作时间：周一至周五 9:00-17:30</p>
        <p class="addr">
          公司地址：天津海河教育园区新慧路1号管理中心三区二层233室
        </p>
        <p class="email">企业邮箱：tiankezhiyou@163.com</p>
      </div>
    </div>
    <div class="footer">
      版权所有 ©2023天津天科智友科技有限公司 津ICP备2023002978号-2
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";
export default {
  name: "ContactUs",
  setup() {
    onMounted(() => {});
  },
};
</script>
<style scoped lang="scss">
@keyframes fadebackground {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.contact-wrapper {
  box-sizing: border-box;
  background: url(../assets/images/contact-bg.png) no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  p {
    margin: 0;
  }
  .contact-content {
    display: flex;
    padding: 16vh 7.5% 0;
    .contact-left {
      width: 60%;
      margin-top: 0.4rem;
      display: flex;
      justify-content: flex-start;
      position: relative;
      animation: fadebackground 3s;
      .map {
        height: 3rem;
        width: auto;
        position: relative;
      }
      .location {
        position: absolute;
        top: 1.6rem;
        left: 0.8rem;
        font-size: 0.146rem; /* 28/192 */
        color: #b0aeae;
      }
      .desc-box {
        position: absolute;
        top: 0.32rem;
        left: 1.3rem;
        height: 1.493rem /* 348/192 */;
        width: 3.24rem /* 622/192 */;
        // min-width: 472px;
        padding: 0.234rem /* 45/192 */ 0.156rem /* 30/192 */;
        box-sizing: border-box;
        border: 1px solid #e2e2e2;
        border-radius: 5px;
        .map-tit {
          font-size: 0.104rem /* 20/192 */;
          text-align: left;
        }
        .map-desc,
        .map-desc2 {
          font-size: 0.083rem /* 16/192 */;
          text-align: justify;
          margin-top: 0.083rem /* 16/192 */;
          line-height: 1.5;
        }
        .map-desc2 {
          clear: both;
        }

        .word {
          float: left;
          width: 1.25rem;
        }
        img {
          float: right;
          margin-left: 0.156rem /* 30/192 */;
          width: 1.479rem /* 284/192 */;
          height: 0.786rem /* 151/192 */;
        }
      }
    }
    .contact-right {
      width: 40%;
      margin-top: 0.72rem;
      text-align: left;
      animation: fadebackground 3s;
      .tit {
        font-size: 0.177rem /* 34/192 */;
        margin-bottom: 0.127rem;
      }
      .time,
      .addr,
      .email {
        font-size: 0.094rem /* 18/192 */;
        margin-bottom: 0.094rem; /* 18/192 */
      }
    }
  }
  .footer {
    font-size: 14px;
    position: fixed;
    bottom: 40px;
    width: 100%;
  }
}
</style>
